module.exports = __webpack_public_path__ + "img/doc_2_preview.d8cd4c80.jpg";